import * as yup from 'yup'

export default yup.object({
  password: yup.string().required('Contraseña requerida.'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Las contraseñas deben coincidir.')
})
